(function () {
  'use strict';
  var doc = document;
  var root = doc.documentElement;
  var header = doc.querySelector('[data-ksu-header]');
  var deskNav = doc.querySelector('[data-ksu-desktop-nav]');
  var drawer = doc.querySelector('[data-ksu-drawer]');
  var backdrop = doc.querySelector('[data-ksu-drawer-backdrop]');
  var openBtn = doc.querySelector('[data-ksu-drawer-open]');
  var searchBtn = doc.querySelector('[data-ksu-mobile-search]');
  var rootPage = drawer && drawer.querySelector('[data-ksu-page-root]');
  var returnFocus = null;
  var pageOpener = null;
  var inertBackground = [];
  var desktop = window.matchMedia('(min-width: 1320px)');
  var navOverlay = null;
  var hoverTimer;
  var config = window.KSU_NAV || {};
  var focusableSelector = 'a[href],button:not([disabled]),input:not([disabled]),summary,[tabindex="0"]';

  function focusables(container) {
    return Array.from(container.querySelectorAll(focusableSelector)).filter(function (el) {
      return !el.closest('[inert],[hidden]') && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden';
    });
  }

  function setBackgroundInert(on) {
    if (!on) {
      inertBackground.forEach(function (el) { el.inert = false; });
      inertBackground = [];
      return;
    }
    for (var branch = drawer; branch && branch !== doc.body; branch = branch.parentElement) {
      Array.from(branch.parentElement.children).forEach(function (el) {
        if (el !== branch && el !== backdrop && !el.inert && !/^(SCRIPT|STYLE|LINK)$/.test(el.tagName)) {
          el.inert = true;
          inertBackground.push(el);
        }
      });
    }
  }

  function showPage(page, target) {
    if (!drawer || !page) return;
    drawer.querySelectorAll('.ksu-drawer__page').forEach(function (p) {
      var current = p === page;
      p.classList.toggle('is-current', current);
      p.setAttribute('aria-hidden', String(!current));
      p.inert = !current;
    });
    drawer.scrollLeft = 0;
    if (target) target.focus({ preventScroll: true });
  }

  function setDrawer(open, trigger, search) {
    if (!drawer) return;
    if (open) {
      closeAllPanels();
      returnFocus = trigger || doc.activeElement;
      drawer.inert = false;
      drawer.setAttribute('aria-hidden', 'false');
      drawer.classList.add('is-open');
      backdrop.hidden = false;
      backdrop.classList.add('is-open');
      root.classList.add('ksu-drawer-lock');
      showPage(rootPage);
      setBackgroundInert(true);
      (search ? rootPage.querySelector('[data-ksu-search-input]') : rootPage.querySelector('[data-ksu-drawer-close]')).focus({ preventScroll: true });
    } else {
      setBackgroundInert(false);
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      drawer.inert = true;
      backdrop.classList.remove('is-open');
      backdrop.hidden = true;
      root.classList.remove('ksu-drawer-lock');
      hideSearchResults(drawer);
      showPage(rootPage);
      if (returnFocus && returnFocus.isConnected && returnFocus.getClientRects().length) returnFocus.focus();
    }
    [openBtn, searchBtn].forEach(function (btn) { if (btn) btn.setAttribute('aria-expanded', String(open)); });
  }

  if (openBtn) openBtn.addEventListener('click', function () { setDrawer(true, openBtn); });
  if (searchBtn) searchBtn.addEventListener('click', function () { setDrawer(true, searchBtn, true); });
  if (backdrop) backdrop.addEventListener('click', function () { setDrawer(false); });

  if (drawer) {
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-ksu-drawer-close]')) { setDrawer(false); return; }
      if (e.target.closest('[data-ksu-page-back]')) { showPage(rootPage, pageOpener); return; }
      var opener = e.target.closest('[data-ksu-open-page]');
      if (!opener) return;
      var page = drawer.querySelector('[data-ksu-page="' + opener.dataset.ksuOpenPage + '"]');
      if (page) {
        pageOpener = opener;
        hideSearchResults(drawer);
        showPage(page, page.querySelector('[data-ksu-page-back]'));
        page.querySelector('.ksu-drawer__scroll').scrollTop = 0;
      }
    });
  }

  doc.querySelectorAll('[data-ksu-itemacc]').forEach(function (box, index) {
    var toggle = box.querySelector('.ksu-itemacc__toggle');
    var body = box.querySelector('[data-ksu-itemacc-body]');
    body.id = 'KsuAccessories-' + index;
    toggle.setAttribute('aria-controls', body.id);
    toggle.addEventListener('click', function () {
      var opening = toggle.getAttribute('aria-expanded') !== 'true';
      box.classList.toggle('is-open', opening);
      toggle.setAttribute('aria-expanded', String(opening));
      body.hidden = !opening;
      body.inert = !opening;
    });
  });

  function closeAllPanels(restoreFocus) {
    clearTimeout(hoverTimer);
    if (!deskNav) return;
    deskNav.querySelectorAll('[data-ksu-panel-item]').forEach(function (item) {
      var panel = item.querySelector('.ksu-panel');
      var btn = item.querySelector('button.ksu-nav__link');
      if (restoreFocus && panel.contains(doc.activeElement)) btn.focus();
      item.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
      panel.setAttribute('aria-hidden', 'true');
      panel.inert = true;
    });
    if (navOverlay) navOverlay.classList.remove('is-open');
    root.classList.remove('ksu-nav-open');
  }

  function openPanel(item) {
    if (!desktop.matches || item.classList.contains('is-open')) return;
    closeAllPanels();
    hideSearchResults(header);
    header.querySelectorAll('.ksu-search__surface').forEach(function (el) { el.hidden = true; });
    header.querySelectorAll('[data-ksu-search-open]').forEach(function (el) { el.setAttribute('aria-expanded', 'false'); });
    item.classList.add('is-open');
    item.querySelector('button.ksu-nav__link').setAttribute('aria-expanded', 'true');
    var panel = item.querySelector('.ksu-panel');
    panel.setAttribute('aria-hidden', 'false');
    panel.inert = false;
    if (!navOverlay) {
      navOverlay = doc.createElement('div');
      navOverlay.className = 'ksu-nav-overlay';
      navOverlay.setAttribute('aria-hidden', 'true');
      navOverlay.addEventListener('click', function () { closeAllPanels(); });
      doc.body.appendChild(navOverlay);
    }
    navOverlay.classList.add('is-open');
    root.classList.add('ksu-nav-open');
  }

  if (deskNav && header) {
    if (window.matchMedia('(pointer: fine)').matches) {
      deskNav.addEventListener('mouseover', function (e) {
        var item = e.target.closest('[data-ksu-panel-item]');
        if (!item) return;
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(function () { openPanel(item); }, 160);
      });
      header.addEventListener('mouseleave', function () {
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(function () { closeAllPanels(); }, 240);
      });
      header.addEventListener('mouseenter', function () { clearTimeout(hoverTimer); });
    }
    deskNav.addEventListener('click', function (e) {
      var btn = e.target.closest('button.ksu-nav__link');
      if (!btn) return;
      var item = btn.closest('[data-ksu-panel-item]');
      if (item.classList.contains('is-open')) closeAllPanels(); else openPanel(item);
    });
    deskNav.addEventListener('keydown', function (e) {
      var btn = e.target.closest('button.ksu-nav__link');
      if (!btn || e.key !== 'ArrowDown') return;
      e.preventDefault();
      var item = btn.closest('[data-ksu-panel-item]');
      openPanel(item);
      var targets = focusables(item.querySelector('.ksu-panel'));
      if (targets.length) targets[0].focus();
    });
    header.addEventListener('focusout', function () {
      setTimeout(function () { if (!header.contains(doc.activeElement)) closeAllPanels(); }, 0);
    });
    doc.addEventListener('click', function (e) { if (!header.contains(e.target)) closeAllPanels(); });
  }

  doc.querySelectorAll('[data-ksu-acczone]').forEach(function (zone, zoneIndex) {
    var tabs = Array.from(zone.querySelectorAll('[data-ksu-acc-tab]'));
    var panels = Array.from(zone.querySelectorAll('[data-ksu-acc-panel]'));
    function activate(index, focus) {
      tabs.forEach(function (tab, i) {
        tab.classList.toggle('is-active', i === index);
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
      });
      panels.forEach(function (panel, i) {
        panel.classList.toggle('is-active', i === index);
        panel.hidden = i !== index;
        panel.inert = i !== index;
      });
      if (focus) tabs[index].focus();
    }
    tabs.forEach(function (tab, i) {
      tab.id = 'KsuTab-' + zoneIndex + '-' + i;
      panels[i].id = 'KsuTabPanel-' + zoneIndex + '-' + i;
      tab.setAttribute('aria-controls', panels[i].id);
      panels[i].setAttribute('aria-labelledby', tab.id);
      tab.addEventListener('click', function () { activate(i); });
      tab.addEventListener('keydown', function (e) {
        var next = i;
        if (e.key === 'ArrowRight') next = (i + 1) % tabs.length;
        else if (e.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = tabs.length - 1;
        else return;
        e.preventDefault(); activate(next, true);
      });
    });
    activate(0);
  });

  function hideSearchResults(container) {
    if (!container) return;
    container.querySelectorAll('[data-ksu-search-results]').forEach(function (pop) { pop.hidden = true; });
    container.querySelectorAll('[data-ksu-search-input]').forEach(function (input) {
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
    });
  }

  doc.querySelectorAll('[data-ksu-search]').forEach(function (shell) {
    var input = shell.querySelector('[data-ksu-search-input]');
    var pop = shell.querySelector('[data-ksu-search-results]');
    var list = shell.querySelector('[data-ksu-search-list]');
    var all = shell.querySelector('[data-ksu-search-all]');
    var status = shell.querySelector('[data-ksu-search-status]');
    var trigger = shell.querySelector('[data-ksu-search-open]');
    var surface = shell.querySelector('.ksu-search__surface');
    var close = shell.querySelector('[data-ksu-search-close]');
    var timer, controller;
    var version = 0;
    var active = -1;
    if (!input || !pop) return;

    function dismiss() { version++; if (controller) controller.abort(); clearTimeout(timer); hideSearchResults(shell); active = -1; }
    function closeSurface(focus) {
      dismiss();
      if (surface) surface.hidden = true;
      if (trigger) trigger.setAttribute('aria-expanded','false');
      if (focus && trigger) trigger.focus();
    }
    if (trigger) trigger.addEventListener('click', function () {
      if (!surface.hidden) { closeSurface(true); return; }
      closeAllPanels(); surface.hidden = false; trigger.setAttribute('aria-expanded','true'); input.focus();
    });
    if (close) close.addEventListener('click', function () { closeSurface(true); });

    function select(index) {
      var options = Array.from(list.querySelectorAll('[role="option"]'));
      active = index;
      options.forEach(function (el,i) { el.setAttribute('aria-selected',String(i === index)); });
      if (options[index]) { input.setAttribute('aria-activedescendant',options[index].id); options[index].scrollIntoView({block:'nearest'}); }
      else input.removeAttribute('aria-activedescendant');
    }

    function search() {
      clearTimeout(timer);
      if (controller) controller.abort();
      var query = input.value.trim();
      var current = ++version;
      hideSearchResults(shell);
      active = -1;
      if (!query) { list.replaceChildren(); status.textContent = ''; return; }
      status.textContent = config.searchLoading || '';
      timer = setTimeout(function () {
        controller = new AbortController();
        var url = new URL(config.suggestUrl || '/search/suggest.json',location.origin);
        url.searchParams.set('q',query);
        url.searchParams.set('resources[type]','product');
        url.searchParams.set('resources[limit]','4');
        url.searchParams.set('resources[options][unavailable_products]','hide');
        fetch(url.toString(),{signal:controller.signal,credentials:'same-origin'})
          .then(function (r) { if (!r.ok) throw new Error('Search unavailable'); return r.json(); })
          .then(function (data) {
            if (current !== version || query !== input.value.trim() || (drawer.contains(shell) && !drawer.classList.contains('is-open'))) return;
            var products = data.resources && data.resources.results && data.resources.results.products || [];
            list.replaceChildren();
            products.forEach(function (product,i) {
              var li = doc.createElement('li'); li.setAttribute('role','presentation');
              var link = doc.createElement('a'); link.className = 'ksu-search__item'; link.href = product.url; link.id = input.id + '-Option-' + i;
              link.setAttribute('role','option'); link.setAttribute('aria-selected','false'); link.tabIndex = -1;
              var thumb = doc.createElement('span'); thumb.className = 'ksu-search__thumb';
              if (product.featured_image && product.featured_image.url) {
                var image = doc.createElement('img');
                var imageUrl = new URL(product.featured_image.url,location.origin); imageUrl.searchParams.set('width','100');
                image.src = imageUrl.toString(); image.alt = ''; image.width = 38; image.height = 38; thumb.append(image);
              }
              var name = doc.createElement('span'); name.className = 'ksu-search__name'; name.textContent = product.title;
              link.append(thumb,name); li.append(link); list.append(li);
            });
            all.href = (config.searchUrl || '/search') + '?q=' + encodeURIComponent(query);
            all.textContent = (config.searchAll || '').replace('__QUERY__',query);
            pop.hidden = false;
            input.setAttribute('aria-expanded','true');
            status.textContent = (config.searchCount || '').replace('__COUNT__',String(products.length));
          }).catch(function (error) { if (current === version && error.name !== 'AbortError') { hideSearchResults(shell); status.textContent = ''; } });
      },220);
    }
    input.addEventListener('input',search);
    input.addEventListener('focus',function () { if (input.value.trim()) search(); });
    input.addEventListener('keydown',function (e) {
      var options = list.querySelectorAll('[role="option"]');
      if ((e.key === 'ArrowDown' || e.key === 'ArrowUp') && !pop.hidden && options.length) {
        e.preventDefault();
        select(e.key === 'ArrowDown' ? (active+1)%options.length : (active-1+options.length)%options.length);
      } else if (e.key === 'Enter' && !pop.hidden && active >= 0 && options[active]) {
        e.preventDefault(); options[active].click();
      } else if (e.key === 'Escape' && (!pop.hidden || surface && !surface.hidden)) {
        e.preventDefault(); e.stopPropagation(); if (surface) closeSurface(true); else dismiss();
      }
    });
    shell.querySelector('form').addEventListener('submit',function(e) { if (!input.value.trim()) { e.preventDefault(); input.focus(); } });
    doc.addEventListener('click',function(e) { if (!shell.contains(e.target) && !e.target.closest('[data-ksu-mobile-search]')) closeSurface(false); });
    shell.addEventListener('keydown',function(e) { if (e.key === 'Escape' && surface) { e.preventDefault(); e.stopPropagation(); closeSurface(true); } });
  });

  doc.addEventListener('keydown',function(e) {
    if (e.key === 'Escape') {
      closeAllPanels(true);
      if (drawer && drawer.classList.contains('is-open')) { e.preventDefault(); setDrawer(false); }
    }
    if (e.key === 'Tab' && drawer && drawer.classList.contains('is-open')) {
      var page = drawer.querySelector('.ksu-drawer__page.is-current');
      var targets = focusables(page);
      if (!targets.length) return;
      var first = targets[0], last = targets[targets.length-1];
      if (!page.contains(doc.activeElement)) { e.preventDefault(); first.focus(); }
      else if (e.shiftKey && doc.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && doc.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
  desktop.addEventListener('change',function() {
    closeAllPanels();
    if (drawer && drawer.classList.contains('is-open')) setDrawer(false);
    header.querySelectorAll('.ksu-search__surface').forEach(function(el){el.hidden=true;});
    hideSearchResults(header);
  });

  var CART_MUTATION_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var countTimer = null;

  function setCartCount(n) {
    var icon = doc.querySelector('[data-ksu-cart-icon]');
    if (!icon) return;
    var badge = icon.querySelector('.ksu-header__cart-count');
    if (n > 0) {
      if (!badge) {
        badge = doc.createElement('span');
        badge.className = 'ksu-header__cart-count';
        icon.appendChild(badge);
      }
      badge.textContent = n > 99 ? '99+' : String(n);
      icon.setAttribute('aria-label', 'Cart (' + n + ' items)');
    } else if (badge) {
      badge.remove();
      icon.setAttribute('aria-label', 'Cart (0 items)');
    }
  }

  function refreshCartCount() {
    clearTimeout(countTimer);
    countTimer = setTimeout(function () {
      fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          if (c && typeof c.item_count === 'number') setCartCount(c.item_count);
        })
        .catch(function () {});
    }, 250);
  }

  // Intercept fetch-based cart mutations (theme cart drawer, apps)
  if (window.fetch) {
    var origFetch = window.fetch;
    window.fetch = function () {
      var arg = arguments[0];
      var url = typeof arg === 'string' ? arg : (arg && arg.url) || '';
      var promise = origFetch.apply(this, arguments);
      if (CART_MUTATION_RE.test(url)) {
        promise.then(function () { refreshCartCount(); }).catch(function () {});
      }
      return promise;
    };
  }

  // Intercept XHR-based cart mutations (jQuery ajax)
  if (window.XMLHttpRequest) {
    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      this._ksuCartMutation = CART_MUTATION_RE.test(url || '');
      return origOpen.apply(this, arguments);
    };
    var origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () {
      if (this._ksuCartMutation) {
        this.addEventListener('loadend', refreshCartCount);
      }
      return origSend.apply(this, arguments);
    };
  }

  // Common custom events some scripts dispatch after cart changes
  ['cart:updated', 'cart:refresh', 'cart:change', 'cart:build', 'ajaxCart:updated'].forEach(function (ev) {
    doc.addEventListener(ev, refreshCartCount);
  });

  // Sync when returning via back/forward cache
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) refreshCartCount();
  });


})();
